import {inject, Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {AppEventBus} from "../../common/event-buses/app.event-bus";
import {catchError, Observable, throwError} from "rxjs";
import {IHttpHandler} from "./handlers/IHttpHandler";
import {ProgressTrackingHandler} from "./handlers/ProgressTrackingHandler";
import {map} from "rxjs/operators";

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  private readonly appEventBus = inject(AppEventBus);

  private readonly handlers: Array<IHttpHandler>;

  constructor() {
    this.handlers = [
      new ProgressTrackingHandler(this.appEventBus),
    ];
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.handlers.forEach((handler) => {
      if(handler.canHandleRequest(req)) {
        req = handler.handleRequest(req);
      }
    });

    return next.handle(req).pipe(map((event: HttpEvent<any>) => {
      this.handlers.forEach((handler) => {
        if(handler.canHandleResponse(req, event)) {
          event = handler.handleResponse(req, event);
        }
      });

      return event;
    }), catchError((error) => {
      this.handlers.forEach((handler) => {
        if(handler.canHandleError(req, error)) {
          handler.handleError(req, error);
        }
      });

      return throwError(error);
    }));
  }
}
